import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  DateField,
  Resource,
  ReferenceInput,
  ReferenceField,
  Filter,
  Datagrid,
  SelectInput,
  Show,
  SimpleShowLayout,
  AutocompleteInput,
  useEditController
} from "react-admin";
import RawMaterialCategoryMaterialCategoryInput from "../components/RawMaterialCategoryMaterialCategoryInput";

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput alwaysOn label="Raw Material Category" source="rawMaterialCategoryId" reference="rawMaterialCategory" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput alwaysOn label="Material Category" source="materialCategoryId" reference="materialsCategory" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>

    <ReferenceInput alwaysOn label="Processing" source="processingId" reference="process/processing" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const DefaultMaterialProcessingList = (props) => {
  return (
    <List {...props} filters={<Filters />}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <ReferenceField label="Raw Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
            <TextField source="rawMaterialCategory.name" />
          </ReferenceField>
          <ReferenceField label="Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
            <TextField source="materialCategory.name" />
          </ReferenceField>
          <ReferenceField label="Processing" source="processingId" reference="process/processing">
            <TextField source="name" />
          </ReferenceField>
        </Datagrid>
      </div>
    </List>
  );
};

const CreateDefaultMaterialProcessing = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <RawMaterialCategoryMaterialCategoryInput required />
        <ReferenceInput
          label="Processing"
          source="processingId"
          reference="process/processing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" required={true} />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

const EditDefaultMaterialProcessing = (props) => {
  const { record, isLoading } = useEditController(props);
  if (isLoading) return <div>Loading...</div>;
  return (
    <Edit {...props}>
      <SimpleForm>
        <RawMaterialCategoryMaterialCategoryInput record={record} required />
        <ReferenceInput
          label="Processing"
          source="processingId"
          reference="process/processing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" required={true} />
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

const ShowDefaultMaterialProcessing = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <ReferenceField label="Raw Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
          <TextField source="rawMaterialCategory.name" />
        </ReferenceField>
        <ReferenceField label="Material Category" source="rawMaterialCategoryMaterialCategoryId" reference="rawMaterialCategoryMaterialCategory">
          <TextField source="materialCategory.name" />
        </ReferenceField>
        <ReferenceField label="Processing" source="processingId" reference="process/processing">
          <TextField source="name" />
        </ReferenceField>
      </SimpleShowLayout>
    </Show>
  );
};

const defaultMaterialProcessingResource = (props) => (
  <Resource
    name="defaultMaterialProcessing"
    list={DefaultMaterialProcessingList}
    create={CreateDefaultMaterialProcessing}
    edit={EditDefaultMaterialProcessing}
    show={ShowDefaultMaterialProcessing}
    options={{
      label: 'Default Material Processing',
      menuGroup: 'Bcome'
    }}
    {...props}
  />
);

export default defaultMaterialProcessingResource;
